import "assets/vendors/style";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";

import store from "./appRedux/store";
import AppRouter from "./routes";
import axios from "axios";

const NextApp = () => {
  /* cookies will be received and sent with each request made using axios. */
  axios.defaults.withCredentials = true;

  return (
    <Provider store={store}>
      <RouterProvider router={AppRouter} />
    </Provider>
  );
};

export default NextApp;
